import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { UpdateBasicInfo } from "../../app/data/terminal-details/models";
import { initialUpdateBasicInfoState } from "./BasicInfoState";

const terminalService = TerminalService.getInstance();

export const updateBasicInfoSlice = createSlice({
    name: "updateBasicInfo",
    initialState: initialUpdateBasicInfoState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setUpdateBasicInfo: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    setUpdateBasicInfo,
    error
} = updateBasicInfoSlice.actions;

export const updateBasicInfoSelector = (state: IState) => state.updateBasicInfo;

// update terminal basic info by terminal number
export const updateTerminalBasicInfoById = (terminalNumber: string, data: UpdateBasicInfo, callback?: () => void, errorCallback?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.updateTerminalSummaryByBasicInfo(terminalNumber, data);
    if (response.ok()) {
        dispatch(setUpdateBasicInfo(response.data));
        callback?.();
    } else {
        if (response.getError()) {
            dispatch(error(response.getError()));
            if(typeof response.getError() === "string" && response.getError() !== "")
                errorCallback?.(response?.getError() || "Error! Please try again later...");
            else
                errorCallback?.("Error! Please try again later...");
        }
    }
};

const updateBasicInfoReducer = updateBasicInfoSlice.reducer;
export default updateBasicInfoReducer;
